import axios, { AxiosError, AxiosRequestConfig } from "axios";

import { CONSUMER_JWT_KEY } from "../constants";
import { RequestOptions } from "./request-options";
import { RequestResult } from "./request-result";

/**
 * @param options - RequestOptions
 * @param isAutoLogin
 * @returns Promise<RequestResult<T>>
 */
export async function request<T>(
  options: RequestOptions,
  isAutoLogin = false,
): Promise<RequestResult<T>> {
  const { api, params } = options;

  const { url, method = "get", timeout = 60_000, headers = {} } = api;

  if (!url) {
    const msg = "接口配置缺少关键字段[url]";

    console.error(msg);

    return {
      success: false,
      data: null,
      message: msg,
      code: 400,
    };
  }

  const config: AxiosRequestConfig = {
    url,
    method,
    timeout,
    headers: {
      accept: "application/json;v=1",
    },
  };

  const userToken = localStorage.getItem(CONSUMER_JWT_KEY);

  if (userToken) {
    config.headers = {
      Authorization: `Bearer ${userToken}`,
    };
  }

  if (params) {
    if (config.method?.toUpperCase() === "GET") {
      config.params = params;
    } else {
      config.data = params;
    }
  }

  if (JSON.stringify(headers) !== "{}") {
    config.headers = Object.assign(
      {},
      {
        ...config.headers,
        ...headers,
      },
    );
  }

  let result: RequestResult<T> = {
    success: false,
    data: null,
    message: "",
    code: 500,
  };

  try {
    const response = await axios<{ code: number; message: string; data: T }>(
      config,
    );

    if (response.data) {
      const data = response.data;

      if (data.code === 0) {
        result = {
          success: true,
          data: data.data,
          message: "success",
          code: 0,
        };
      } else {
        result.message = `[${data.code}]` + `${data.message}`;
        result.code = data.code;
      }
    } else {
      result.message = "接口没有返回数据";
    }
  } catch (e) {
    if (e instanceof AxiosError) {
      if (e.response) {
        result.message = e.response.data.msg || e.response.statusText;
        result.code = e.response.data.code || e.response.status;

        // const currentPath = window.location.pathname + window.location.search;

        switch (e.response.status) {
          case 401:
            localStorage.removeItem(CONSUMER_JWT_KEY);

            // window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
            if (!isAutoLogin) {
              // return request(options, true);
            }
            break;
        }
      } else if (
        Object.prototype.hasOwnProperty.call(e, "code") &&
        e.code === "ECONNABORTED"
      ) {
        result.message = "请求超时";
      } else if (e.message && e.message === "Network Error") {
        result.message = "无法连接到服务器";
      } else {
        if (e.message) {
          result.message = e.message;
        } else {
          console.error(e);
        }
      }
    } else {
      console.error(e);
      result.message = "未知错误";
    }
  }

  return result;
}
